import React, {useEffect, useState} from "react";
// reactstrap components
import {Button, Form, Input, Container, Row, Col, Alert} from "reactstrap";

// core components
import NavbarTop from "./NavbarTop";
import Footer from "./Footer";
import axios from "axios";

function ContactUs() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("contact-page");
    // window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("contact-page");
    };
  });

  const [first, setFirst] = useState("");
  const [last, setLast] = useState("");
  const [query, setQuery] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState(false);

  const submitHandler = async () => {
    const formData = new FormData();
    formData.append("contact_us[first_name]", first);
    formData.append("contact_us[last_name]", last);
    formData.append("contact_us[query]", query);

    console.log(first, last, query);

    if(first!=="" && last!=="" && query!=="") {
      const response = await axios.post("https://swatch-v1.herokuapp.com/api/v1/contact_us", formData);
      console.log(response);
      if (response.status === 200 && response.data.status === 'success') {
        setShowAlert(true);
        setShowError(false);
      }
    } else {
      setShowAlert(false);
      setShowError(true);
    }

  }

  return (
    <>
      <NavbarTop/>
      <div className="main">
        <div className="section section-gray">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">Get in touch with us</h2>
                <p>
                  Collaboratively administrate empowered markets via
                  plug-and-play networks. Dynamically procrastinate B2C users
                  after installed base benefits. Dramatically visualise customer
                  directed convergence without revolutionary ROI.
                </p>
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="6">
                <h3 className="title">
                  <small>Find us on social networks</small>
                </h3>
                <Button className="btn-just-icon mr-1" color="twitter">
                  <i className="fa fa-twitter"/>
                </Button>
                <Button className="btn-just-icon mr-1" color="facebook">
                  <i className="fa fa-facebook"/>
                </Button>
                <Button className="btn-just-icon mr-1" color="google">
                  <i className="fa fa-google"/>
                </Button>
                <Button className="btn-just-icon mr-1" color="dribbble">
                  <i className="fa fa-dribbble"/>
                </Button>
                <Button className="btn-just-icon mr-1" color="instagram">
                  <i className="fa fa-instagram"/>
                </Button>
                <Button className="btn-just-icon" color="youtube">
                  <i className="fa fa-youtube"/>
                </Button>
              </Col>
            </Row>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="6">
                <h3 className="title">
                  <small>Or drop us a note</small>
                </h3>
                <Form className="contact">
                  <Row>
                    <Col md="6">
                      <Input placeholder="First Name" type="text" value={first}
                             onChange={(event) => setFirst(event.target.value)}/>
                    </Col>
                    <Col md="6">
                      <Input placeholder="Last Name" type="text" value={last}
                             onChange={(event) => setLast(event.target.value)}/>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Input placeholder="Email" type="text" value={email}
                             onChange={(event) => setEmail(event.target.value)} />
                    </Col>
                    <Col md="6">
                      <Input placeholder="Subject" type="text" value={subject}
                             onChange={(event) => setSubject(event.target.value)}/>
                    </Col>
                  </Row>
                  <Input placeholder="Message" rows="7" type="textarea" value={query}
                         onChange={(event) => setQuery(event.target.value)}/>
                  <Row>
                    <Col className="ml-auto mr-auto" md="6">
                      <Button block className="btn-round" color="primary" onClick={submitHandler}>
                        Send
                      </Button>
                    </Col>
                  </Row>
                </Form>
                <Row style={{marginTop: "50px"}}>
                  <Col className="ml-auto mr-auto">
                    <Alert color="info" isOpen={showAlert} toggle={() => setShowAlert(false)}>
                      <b>Thank you for contacting Us!</b> We will get back to you as soon as possible.
                    </Alert>
                    <Alert color="danger" isOpen={showError} toggle={() => setShowError(false)}>
                      First name, last name and query should not be empty.
                    </Alert>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      <Footer/>
    </>
  );
}

export default ContactUs;
